import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

/**
 * STAFF API CONFIGURATION
 * Integrated with pms-api REST endpoints: /api/v1/staff
 */
export const staffConfig = {
  /* -------------------------------- GET --------------------------------- */

  getAllStaffs: {
    key: "getAllStaffs",
    url: "/api/v1/staff",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getStaffById: {
    key: "getStaffById",
    url: (params) => `/api/v1/staff/${params.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  // Reuses the roles endpoint — staff pages need the same role list
  getAllRolesForStaff: {
    key: "getAllRolesForStaff",
    url: "/api/v1/roles",
    method: "GET",
    options: {
      ...QUERY_PRESETS.STATIC,
    },
  },

  getDeletedStaffs: {
    key: "getDeletedStaffs",
    url: "/api/v1/staff/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getStaffStats: {
    key: "getStaffStats",
    url: "/api/v1/staff/stats",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  /* ------------------------------- POST -------------------------------- */

  createStaff: {
    key: "createStaff",
    url: "/api/v1/staff",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllStaffs", "getStaffStats"],
    },
  },

  /* ----------------------------- PATCH / DELETE ------------------------ */

  updateStaff: {
    key: "updateStaff",
    url: (data) => `/api/v1/staff/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllStaffs", "getStaffById", "getStaffStats"],
    },
  },

  softDeleteStaff: {
    key: "softDeleteStaff",
    url: (data) => `/api/v1/staff/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllStaffs", "getDeletedStaffs", "getStaffStats"],
    },
  },

  restoreStaff: {
    key: "restoreStaff",
    url: (data) => `/api/v1/staff/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllStaffs", "getDeletedStaffs", "getStaffStats"],
    },
  },

  // TODO: no hard-delete endpoint in pms-api yet
  hardDeleteStaff: {
    key: "hardDeleteStaff",
    url: (data) => `/api/v1/staff/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllStaffs", "getDeletedStaffs"],
    },
  },
};
